export default __webpack_public_path__ + "static/media/green_teamwork.2fbc3cd7.svg";